import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { getFieldName } from '../../../../helpers/StateInterpreters';

export const EditMergedFieldStatus = ({
  LangFile,
  mergedFields,
  mergedFieldInputs,
  hectaresToAdd,
  renderFieldInput,
  setMergeFieldInput,
}) => {
  const { fieldA, fieldB } = mergedFields;

  const renderSummaryRow = (label, value, style = {}, idx) => (
    <Box
      key={`${label}-${idx}`}
      style={style}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant="body2">{label}</Typography>
      <Typography variant="body2" style={{ fontWeight: 'bold', color: '#2c3e50' }}>
        {value}
      </Typography>
    </Box>
  );

  return (
    <Box>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: '8px',
          backgroundColor: '#ddd',
        }}
      />

      {renderSummaryRow(
        getFieldName(fieldA, LangFile) + ':',
        `${fieldA.size.toFixed(2)} ha`,
        null,
        0
      )}
      {renderSummaryRow(
        getFieldName(fieldB, LangFile) + ':',
        `${fieldB.size.toFixed(2)} ha`,
        { marginBottom: '20px' },
        1
      )}

      {renderFieldInput(
        LangFile.MergeFieldsInputDialog.fieldName,
        mergedFieldInputs.fieldName,
        'fieldName',
        hectaresToAdd,
        setMergeFieldInput,
        false
      )}
      {renderFieldInput(
        LangFile.MergeFieldsInputDialog.fieldNumber,
        mergedFieldInputs.fieldNumber,
        'fieldNumber',
        null,
        setMergeFieldInput,
        true
      )}
    </Box>
  );
};
